module.exports = __webpack_public_path__ + "img/软件包.17e84d21.jpg";